export default __webpack_public_path__ + "static/media/rarity6.1a1f843a.mp4";